// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"951b6dbcf877cc86896c","655":"f13762fed379af7f4272"}[chunkId] + ".js";
};